import { COBLibraryAssets } from './types/cob-library.types';

import leftArrowDisabledIcon from './assets/left-arrow-disabled-icon.svg';
import leftArrowIcon from './assets/left-arrow-icon.svg';
import rightArrowIcon from './assets/right-arrow-icon.svg';
import rightArrowDisabledIcon from './assets/right-arrow-disabled.svg';
import topImageCobIcon from './assets/top-Image-cob-icon.svg';
import crossIcon from './assets/cross.svg';
import formInstruction from './assets/forminstruction.svg';
import successIcon from './assets/success.svg';
import exitWarning from './assets/exit-warning.svg';
import attentionIcon from './assets/attention-icon.svg';
import goodWork from './assets/good_work.svg';
import rockStar from './assets/rockstar.svg';
import tinyClear from './assets/tinyClear.svg';

export const COB_LIBRARY_ASSETS: COBLibraryAssets = {
  LEFT_ARROW_DISABLED_ICON: leftArrowDisabledIcon,
  LEFT_ARROW_ICON: leftArrowIcon,
  RIGHT_ARROW_ICON: rightArrowIcon,
  RIGHT_ARROW_DISABLED_ICON: rightArrowDisabledIcon,
  CROSS_ICON: crossIcon,
  TOP_IMAGE_COB_ICON: topImageCobIcon,
  FORM_INSTRUCTION_DIVIDER: formInstruction,
  SUCCESS_ICON: successIcon,
  EXIT_WARNING: exitWarning,
  ATTENTION_ICON: attentionIcon,
  GOOD_WORK: goodWork,
  ROCK_STAR: rockStar,
  ERROR_CROSS: tinyClear,
};
